import { defineComponent as _defineComponent } from 'vue'
import kebabCase from 'lodash/kebabCase';
import mapKeys from 'lodash/mapKeys';
import { computed, useAttrs } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BoxGrid',
  props: {
    title: { default: '' }
  },
  setup(__props: any) {



const attrs = useAttrs();

const bRowAttrs = computed(() => ({
  'align-v': 'stretch',
  'align-h': 'center',
  'align-content': 'stretch',
  cols: 12,
  ...mapKeys(attrs, (v, k) => kebabCase(k)),
}));

return { __sfc: true,attrs, bRowAttrs }
}

})